import Experience from "../../models/experience";

const defaults = {
  skills: () => {
    return {
      git: {
        name: "GitHub",
        data: "82%",
        featured: true
      },
      php: {
        name: "PHP",
        data: "82%",
        featured: true
      },
      javaScript: {
        name: "JavaScript",
        data: "78%",
        featured: true
      },
      java: {
        name: "Java",
        data: "88%",
        featured: true
      },
      html: {
        name: "HTML",
        data: "93%",
        featured: false
      },
      css: {
        name: "CSS",
        data: "77%",
        featured: false
      },
      sql: {
        name: "MySQL & SQLite",
        data: "80%",
        featured: true
      },
      node: {
        name: "NodeJS",
        data: "66%",
        featured: true
      },
      express: {
        name: "Express.js",
        data: "44%",
        featured: false
      },
      vue: {
        name: "Vue.js",
        data: "85%",
        featured: true
      },
      kotlin: {
        name: "Kotlin",
        data: "73%",
        featured: true
      },
      android: {
        name: "Android",
        data: "90%",
        featured: true
      },
      flutter: {
        name: "Flutter Framework",
        data: "96%",
        featured: true
      },
      laravel: {
        name: "Laravel Framework",
        data: "81%",
        featured: false
      },
      dart: {
        name: "Dart",
        data: "87%",
        featured: true
      },
      oop: {
        name: "OOP",
        data: "85%",
        featured: false
      },
      firebase: {
        name: "Firebase",
        data: "70%",
        featured: true
      },
      cloud_functions: {
        name: "Cloud Functions",
        data: "58%",
        featured: true
      },
      python: {
        name: "Python",
        data: "48%",
        featured: false
      },
      wordpress: {
        name: "Wordpress",
        data: "34%",
        featured: false
      }
    };
  },

  categories: () => {
    return {
      all: {
        title: "All Categories",
        tag: "*"
      },

      web: {
        title: "User Interface",
        tag: "user-interface"
      },

      android: {
        title: "Android Development",
        tag: "android"
      },

      design: {
        title: "Design",
        tag: "design"
      },

      server: {
        title: "Server Dependent",
        tag: "server"
      },

      firebase: {
        title: "Firebase Projects",
        tag: "firebase"
      },

      commerce: {
        title: "E-commerce",
        tag: "e-commerce"
      },

      nodejs: {
        title: "Node JS",
        tag: "nodejs"
      }
    };
  },

  stacks: () => {
    return [{
        id: "Portfolio Light",
        title: "Portfolio",
        subtitle: "Light Background",
        location: "/images/portfolio/portfolio-light.gif",
        categories: [defaults.categories().web, defaults.categories().nodejs, defaults.categories().firebase],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().node, defaults.skills().vue]
      },
      {
        id: "Stackreads",
        title: "Online Library",
        subtitle: "Ton of books",
        location: "/images/portfolio/stackreads.gif",
        categories: [defaults.categories().web, defaults.categories().server],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().node, defaults.skills().php, defaults.skills().express]
      },
      {
        id: "Blog",
        title: "Swift Blog",
        subtitle: "Built with Laravel",
        location: "/images/portfolio/blog.gif",
        categories: [defaults.categories().server, defaults.categories().web],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().php, defaults.skills().laravel, defaults.skills().oop]
      },
      {
        id: "G6",
        title: "Creative Design",
        subtitle: "Photoshop",
        location: "/images/portfolio/g6.png",
        categories: [defaults.categories().design],
        tags: []
      },
      {
        id: "Portfolio Dark",
        title: "Portfolio",
        subtitle: "Dark background",
        location: "/images/portfolio/portfolio-dark.gif",
        categories: [defaults.categories().web, defaults.categories().firebase, defaults.categories().nodejs],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().node, defaults.skills().vue]
      },
      {
        id: "Store",
        title: "Andii Market",
        subtitle: "Laravel, Vuejs, Webpack",
        location: "/images/portfolio/store.gif",
        categories: [defaults.categories().server, defaults.categories().nodejs, defaults.categories().web],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().vue, defaults.skills().node, defaults.skills().laravel]
      },
      {
        id: "Vmax XS",
        title: "Valour Max",
        subtitle: "Android Development",
        location: "/images/portfolio/vmax-xs.gif",
        categories: [defaults.categories().android, defaults.categories().firebase],
        tags: [defaults.skills().android, defaults.skills().java, defaults.skills().firebase]
      },
      {
        id: "Penfs",
        title: "Pen Foundation School",
        subtitle: "School Website & Admin Panel",
        location: "/images/portfolio/penfs.gif",
        categories: [defaults.categories().design, defaults.categories().nodejs, defaults.categories().web],
        tags: [defaults.skills().html, defaults.skills().css, defaults.skills().javaScript, defaults.skills().vue, defaults.skills().node, defaults.skills().laravel]
      },
      {
        id: "Vmax MD",
        title: "Valour Max Large",
        subtitle: "Android",
        location: "/images/portfolio/vmax-md.gif",
        categories: [defaults.categories().firebase, defaults.categories().android],
        tags: [defaults.skills().java, defaults.skills().android, defaults.skills().firebase]
      },
      {
        id: "G3",
        title: "Go Designs",
        subtitle: "",
        location: "/images/portfolio/g3.png",
        categories: [defaults.categories().design],
        tags: []
      }
    ];
  },

  work_experience: () => {
    return [
      new Experience("Junior Developer", "3D Hub Africa", null, "Sep 2015", "Feb 2016", "Owerri", null, ["I worked with a design team in validating 3D designs.", "Worked with a development team; codebase & bug fixes.", "Maintained meticulous work-logs and notified supervisors of progress and setbacks.", "Communicated effectively with company managers to understand the training and development needs of teams."], ["Node.js", "JavaScript", "Express.js", "Amazon Web Services"]),

      new Experience("UI/UX Developer", "XTech Co,", null, "Jun 2017", "Oct 2017", "Port Harcourt", null, ["Brought forth excellent creative thinking abilities and skills.", "Served as a friendly, hardworking, and punctual employee.", "Brought forth an exceptional work ethic and committment to company values."], ["Inkscape", "Illustrator", "CorelDraw", "Git", "Visio", "JS", "Imagemagick", "Balsamiq", "UXPin", "Mockups", "Azure", "Material Design"]),

      new Experience("Senior software developer", "Energy Shield LTD", null, "May 2018", "Jan 2019", "Lagos", null, ["Team lead.", "Add support for existing website.", "Project supervision", "Develop information systems.", "Design and develop Mobile support."], ["Git", "Mockups", "Flutter Framework", "Android Studio", "Android SDK"]),

      new Experience("Mobile UI Engineer", "NickTech Solutions and Consulting LTD", null, "August 2019", "March 2020", "Lagos", null, ["Code validation", "Worked well independently and on a team to solve problems.", "Organized and prioritized work to complete assignments in a timely, efficient manner."], ["Android SDK", "Java RE/Java SE", "Flutter", "Kotlin", "Heroku", "HAXM", "Iconic", "Git", "Mockups", "Azure", "AWS", "Material Design", "SimpleXML"])
    ];
  }
};

export default defaults;